import type { IntegrationTools } from 'modules/payroll_integrations_kombo/lib/constants'
import SupplementSyncs from 'modules/payroll_integrations_kombo/store/collections/supplementSyncs'
import SupplementSync from 'modules/payroll_integrations_kombo/store/models/SupplementSync'

class SupplementSyncsStore {
  supplementSyncsByPeriodId: Record<number, Promise<SupplementSync>> = {}
  periodStatusByFetchedPeriodId: Record<number, string> = {}

  defaultSupplementSync(supplementId: number, integrationTool: IntegrationTools): SupplementSync {
    const defaultValues = {
      supplement_id: supplementId,
      pending: true,
      sent_at: '',
      integration_tool: integrationTool,
    }
    return new SupplementSync(defaultValues)
  }

  findSyncBySupplementId(supplementId: number, integrationTool: IntegrationTools): SupplementSync {
    return (
      SupplementSyncs.find(
        (sync: SupplementSync) =>
          sync.supplement_id == supplementId && sync.integrationTool == integrationTool
      ) ?? this.defaultSupplementSync(supplementId, integrationTool)
    )
  }

  isPolicyPeriodFetched(policyPeriodId: number): boolean {
    return policyPeriodId in this.supplementSyncsByPeriodId
  }

  cleanSupplements(policyPeriodId: number): void {
    if (policyPeriodId in this.supplementSyncsByPeriodId) {
      delete this.supplementSyncsByPeriodId[policyPeriodId]
    }
  }

  async collectionByPeriod(policyPeriodId: number): Promise<SupplementSync> {
    return SupplementSyncs.fetch({
      data: { policy_period_id: policyPeriodId },
    })
  }

  async fetch(
    supplementId: number,
    policyPeriodId: number,
    policyPeriodStatus: string,
    integrationTool: IntegrationTools
  ): Promise<SupplementSync> {
    /* When supplement doest exist yet, we want to show it as pending but avoid the fetch */
    if (!supplementId)
      return Promise.resolve(this.defaultSupplementSync(supplementId, integrationTool))

    if (this.periodStatusByFetchedPeriodId[policyPeriodId] !== policyPeriodStatus) {
      /* Force re-fetch supplements syncs when policy period status has changed.*/
      this.cleanSupplements(policyPeriodId)
      this.periodStatusByFetchedPeriodId[policyPeriodId] = policyPeriodStatus
    }
    if (!this.isPolicyPeriodFetched(policyPeriodId)) {
      this.supplementSyncsByPeriodId[policyPeriodId] = this.collectionByPeriod(policyPeriodId)
    }
    await this.supplementSyncsByPeriodId[policyPeriodId]

    return this.findSyncBySupplementId(supplementId, integrationTool)
  }
}

const singleton: SupplementSyncsStore = new SupplementSyncsStore()

export default singleton
